import { useMemo } from "react";
import { COUNTRIES, DEFAULT_DIAL } from "@/lib/countries";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// Controlled phone input with a country-code selector (flag + name + dial code).
// value is the full E.164-style string e.g. "+255700000000"; onChange emits the same.
export default function PhoneInput({ value = "", onChange, testid = "phone", placeholder = "700 000 000" }) {
  const { dial, local } = useMemo(() => {
    const match = COUNTRIES.map((c) => c.dial).sort((a, b) => b.length - a.length).find((d) => value.startsWith(d));
    if (match) return { dial: match, local: value.slice(match.length) };
    return { dial: DEFAULT_DIAL, local: value.replace(/^\+/, "") };
  }, [value]);

  const emit = (d, l) => onChange(`${d}${l.replace(/[^\d]/g, "")}`);

  return (
    <div className="flex gap-2">
      <Select value={dial} onValueChange={(d) => emit(d, local)}>
        <SelectTrigger data-testid={`${testid}-dial`} className="w-32 bg-muted/40 border-black/10 h-11 rounded-xl shrink-0"><SelectValue /></SelectTrigger>
        <SelectContent>
          {COUNTRIES.map((c) => (
            <SelectItem key={c.code} value={c.dial}>
              <span className="flex items-center gap-2"><span className="text-base leading-none">{c.flag}</span> {c.dial}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input data-testid={testid} inputMode="numeric" value={local} onChange={(e) => emit(dial, e.target.value)} placeholder={placeholder} className="bg-muted/40 border-black/10 h-11 rounded-xl flex-1" />
    </div>
  );
}
